import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import { UpdatedDate } from '@/components/LoanTerms/UpdatedDate';
import { FpgPlans } from './components/FpgPlans';
import { RiskFactor } from './components/RiskFactor';
import { FPG_PLANS, LAST_UPDATE } from './constants';
import s from './index.module.scss';

export const LoanTermsFpgVersion01 = (props) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { t } = useTranslation('fpg-v1');
  const [plan, setPlan] = useState(props.plan || FPG_PLANS.standard);
  const queryPlan = searchParams.get('plan');

  useEffect(() => {
    if (queryPlan && Object.values(FPG_PLANS).includes(queryPlan)) {
      setPlan(queryPlan);
    }
  }, [queryPlan]);

  const changePlan = plan => {
    searchParams.set('plan', plan);
    setSearchParams(searchParams);
  };

  return (
    <div className={s.page}>
      <div className="container-inner">
        <h1 className={classnames(s.title, 'f-42 f-500')}>{t('fpg.founder_personal_guarantee')}</h1>
        <div className={s.content}>
          <div>
            <FpgPlans plan={plan} setPlan={changePlan} />
            <div className={classnames(s.desc, 'f-body-regular')}>
              {t('fpg.risk', {
                fee: plan === FPG_PLANS.standard ? '20%' : plan === FPG_PLANS.advanced ? '10%' : '',
              })}
            </div>
            <RiskFactor plan={plan} />
            <div className={classnames(s.note, 'f-body-regular')}>{t('fpg.note')}</div>
          </div>

          <div className={s.how}>
            <div className="f-hero-h4">{t('fpg.how_it_works')}</div>
            <div className={s.box}>
              <div className="f-article-accent">{t('fpg.pick_your_plan')}</div>
              <div className="f-body-regular">
                {t('fpg.before_funding_round')}
              </div>
            </div>
            <div className={s.box}>
              <div className="f-article-accent">{t('fpg.pay_one_time_fee')}</div>
              <div className="f-body-regular">
                {t('fpg.after_fundraising_round')}
              </div>
            </div>
            <div className={s.box}>
              <div className="f-article-accent">{t('fpg.personal_liability_capped')}</div>
              <div className="f-body-regular">
                {t('fpg.event_of_closure')}
              </div>
            </div>
            <div className={s.box}>
              <div className="f-article-accent">{t('fpg.business_failed')}</div>
              <div className="f-body-regular">
                {plan === FPG_PLANS.standard && (
                  <>
                    <div>{t('fpg.standard_plan_1')}</div>
                    <div>{t('fpg.standard_plan_2')}</div>
                    <div>{t('fpg.standard_plan_3')}</div>
                  </>
                )}
                {plan === FPG_PLANS.advanced && (
                  <>
                    <div>{t('fpg.advanced_plan_1')}</div>
                    <div>{t('fpg.advanced_plan_2')}</div>
                    <div>{t('fpg.advanced_plan_3')}</div>
                  </>
                )}
              </div>
            </div>
          </div>
          <UpdatedDate className={s.update} date={LAST_UPDATE} />
        </div>
      </div>
    </div>
  );
};